module.exports = function getResource(label) {
    const resources = { orderSummary: 'Sommaire de la commande' };

    return resources[label];
};
